import { ContentGroup, ContentGroupType } from "@/lib/types";
import { DeleteContentGroupButton } from "./DeleteContentGroupButton";
import { ContentGroupPublishButton } from "./ContentGroupPublishButton";
import { ContentGroupShuffleButton } from "./ContentGroupShuffleButton";
import { ContentGroupPreviewPlaybackButton } from "./ContentGroupPreviewPlaybackButton";

interface Props {
  contentGroup: ContentGroup;
}

export const ContentGroupDetailPageHeader: React.FC<Props> = ({ contentGroup }) => {
  const isRobot = contentGroup.type === ContentGroupType.Robot;
  return (
    <div>
      <div className="flex items-center gap-2">
        <div className="flex-1"></div>
        <ContentGroupPublishButton contentGroupGuid={String(contentGroup.contentGroupGuid)} />
        {!isRobot && <ContentGroupPreviewPlaybackButton contentGroupGuid={contentGroup.contentGroupGuid} />}
        {contentGroup && !isRobot && <ContentGroupShuffleButton contentGroup={contentGroup} />}
        <DeleteContentGroupButton contentGroupGuid={contentGroup.contentGroupGuid} />
        {/* <Popover>
          <PopoverTrigger>
            <Button size="sm">{t("contentGroup.viewDS")}</Button>
          </PopoverTrigger>
          <PopoverContent className="p-4 w-full" side="bottom">
            <div className="bg-muted p-2 font-mono text-sm">{VIEW_DS_URL}</div>
            <div className="mt-4">
              <Button size="sm" onClick={() => window.open(VIEW_DS_URL, "_blank")}>
                {t("contentGroup.openLink")} <ExternalLinkIcon />
              </Button>
            </div>
          </PopoverContent>
        </Popover> */}
      </div>
    </div>
  );
};
